import React from 'react';

import { observer } from 'mobx-react';

export default observer(
  ({
    field, type = 'text', placeholder = null, disabled = false,
  }) => (
    <div>
      <label htmlFor={field.id}>{field.label}</label>
      <input
        {...field.bind({ type, placeholder })}
        id={field.id}
        className="form-control"
        disabled={disabled}
      />
      <br />
      <small className="form-control-error">{field.error}</small>
    </div>
  ),
);
